import { render, staticRenderFns } from "./phonems-audiogram-results.vue?vue&type=template&id=2d53816e&"
import script from "./phonems-audiogram-results.vue?vue&type=script&lang=js&"
export * from "./phonems-audiogram-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports